module.exports = __webpack_public_path__ + "static/cupcake-ef669519c64a8813516cc3a6369bc6ea.png";